import React from "react"

function IconChatDashed({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="chat-dashed"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-chat-dashed"
      {...props}
    >
      <path
        d="M21.771 6.977h-1.309V5.025a.28.28 0 0 0-.28-.28V3.436c.878 0 1.59.712 1.59 1.589v1.952zm0 4.363h-1.309V8.068h1.31v3.272zm0 4.364h-1.309v-3.273h1.31v3.273zm0 5.455v1.046a.655.655 0 0 1-1.149.43l-1.459-1.681.988-.858.923 1.062h-.612v1.047l1.149-.429-.537-.618h.697zm0-4.364v3.273h-1.309v-3.273h1.31zm-5.536 2.32v-1.31h1.63c.19 0 .37.083.494.226l1.077 1.24-.988.86-1.078-1.241.495.225h-1.63zm-4.364 0v-1.31h3.273v1.31h-3.273zm-4.363 0v-1.31h3.272v1.31H7.508zm-4.791-.569 1.003-.84c.054.063.13.1.214.1h2.483v1.309H3.934c-.475 0-.918-.211-1.217-.569zm-.372-4.853h1.31v3.273h-1.31v-3.273zm0-4.363h1.31v3.272h-1.31V9.33zm1.31-4.323v3.232h-1.31l.003-3.314 1.307.082zm3.38-1.57v1.308l-3.119.001a.275.275 0 0 0-.05.008l-.317-1.27c.094-.024.19-.039.327-.046l3.16-.002zm4.364 0v1.308H8.126V3.436H11.4zm4.364 0v1.308H12.49V3.436h3.273zm4.363 0v1.308h-3.272V3.436h3.272z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChatDashed
